import React from "react";
import { useRemote } from "../../../hooks/useRemote";
import { useStreamTime } from "../../../hooks/useStreamTime";
import useGlobalStore from "../../../store/global.store";
import VipOffStreamBottomBar from "./VipOffStreamBottomBar";

const VipOffStreamView = ({ bgImage }) => {
  const { updateView } = useRemote();
  const { getMagicKingVipShowTime, vipOffStreamVideo } = useStreamTime();
  // const setSelectedVipDoor = useGlobalStore(
  //   (state) => state.setSelectedVipDoor
  // );
  const setShowBottomBar = useGlobalStore((state) => state.setShowBottomBar);
  const setShowVipSelector = useGlobalStore(
    (state) => state.setShowVipSelector
  );
  console.log(vipOffStreamVideo);
  const handleBackClick = () => {
    setShowBottomBar(false);
    // setSelectedVipDoor("door2");
    updateView("VIP_door_2_selector", () => {
      setShowVipSelector(true);
      // setSelectedVipDoor("door2");
    });
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        zIndex: 10,
      }}
    >
      {vipOffStreamVideo ? (
        <video
          src={`https://cdn.mywaitserver.live/${vipOffStreamVideo}`}
          autoPlay={true}
          muted={true}
          loop={true}
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
          }}
        />
      ) : (
        <img
          src={bgImage}
          alt="VIP Off Stream"
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
          }}
        />
      )}

      <VipOffStreamBottomBar
        onBackClick={handleBackClick}
        timeText={`${getMagicKingVipShowTime()}`}
      />
    </div>
  );
};

export default VipOffStreamView;
